/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_Coach_RoleInputs */

const en_features_sample_coach_role = /** @type {(inputs: Features_Sample_Coach_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainer`)
};

const pl_features_sample_coach_role = /** @type {(inputs: Features_Sample_Coach_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerka personalna`)
};

/**
* | output |
* | --- |
* | "Personal trainer" |
*
* @param {Features_Sample_Coach_RoleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_coach_role = /** @type {((inputs?: Features_Sample_Coach_RoleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_Coach_RoleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_coach_role(inputs)
	return en_features_sample_coach_role(inputs)
});